module.exports = {
    "en": {
        "...": "...",
        "abc_down": "ABC name Down",
        "abc_up": "ABC name Up",
        "add": "Add",
        "add_painting": "Add painting",
        "add_storage": "Add storage",
        "address": "Address",
        "all": "All",
        "aluminum": "Aluminum",
        "at_work": "At Work",
        "available": "Available",
        "bots": "Bots",
        "cancel": "Cancel",
        "canvas": "Canvas",
        "clear": "Clear",
        "client_prospective": "Client prospective",
        "close": "Close",
        "contact": "Contact",
        "contact_description": "Contact description",
        "contact_info": "Contact info",
        "contact_send_success": "Contact send success",
        "contact_success": "Contact success",
        "contact_us": "Contact us",
        "create": "Create",
        "delete": "Delete",
        "display": "display",
        "done": "Done",
        "drying": "Drying",
        "edit": "Edit",
        "email": "Email",
        "exit_admin_perspective": "Exit admin perspective",
        "filters": "Filters",
        "gouache": "Gouache",
        "graphite": "Graphite",
        "id_down": "ID Down",
        "id_up": "ID Up",
        "ink": "Ink",
        "landscape": "Landscape",
        "main_image": "Main Image",
        "material": "Material",
        "message": "Message",
        "message_sent_successfully": "Your message has been sent successfully!",
        "name": "Name",
        "no": "No",
        "not_available": "Not Available",
        "notes": "Notes",
        "nu_painting_to_display": "Number of paintings to display",
        "oil": "Oil",
        "on": "On",
        "open_form": "Open form",
        "open_storage_panel": "Open storage panel",
        "orientation": "Orientation",
        "paintings": "Paintings",
        "paper": "Paper",
        "portrait": "Portrait",
        "price": "Price",
        "price_down": "Price Down",
        "price_up": "Price Up",
        "publish": "Publish",
        "refresh": "Refresh",
        "register": "Register",
        "reset": "Reset",
        "save": "Save",
        "search": "Search",
        "select": "Select",
        "send": "Send",
        "size": "Size",
        "sketches": "Sketches",
        "sort": "Sort",
        "sort_by": "Sort by",
        "stage": "Stage",
        "storage": "Storage",
        "target_date": "Target date",
        "target_point": "Target point",
        "target_point_up": "Target Point",
        "text": "Text",
        "thank_you_for_contacting": "Thank you for contacting us. We'll get back to you soon.",
        "type": "Type",
        "url_name": "URL Name",
        "waiting_for_varnish": "Waiting for varnish",
        "watercolor": "Watercolor",
        "yes": "Yes"
    },
    "de": {}
};